import PropTypes from "prop-types"
import { Avatar, ListItemAvatar, CircularProgress, ListItem, ListItemText } from "@mui/material"
import { Work } from "@mui/icons-material"
import { appendTimestamp } from "modules/server-notifications/helpers"

function InProgress({ message, targetName, progress, createdAt }) {
  return <ListItem className="inProgress">
    <ListItemAvatar>
      <Avatar>
        <Work />
      </Avatar>
    </ListItemAvatar>
    <CircularProgress
      variant="determinate"
      value={progress}
      style={{ position: "absolute" }}
    />
    <ListItemText primary={message} secondary={appendTimestamp(targetName, createdAt)} />
  </ListItem>
}

InProgress.propTypes = {
  message: PropTypes.string.isRequired,
  targetName: PropTypes.string.isRequired,
  progress: PropTypes.number.isRequired,
  createdAt: PropTypes.string.isRequired,
}

export default InProgress
